<template>
  <div class="" v-if="sources">
    <div class="knd-wrapper-text">
      <h3>Bronnenlijst</h3>
      <div v-html="sources"></div>
    </div>
  </div>
</template>

<script setup>
	import { ref, computed } from 'vue'
	import { mapGetters, useStore } from 'vuex';

	const store = useStore()
	
  const sources = computed(() => store.getters.sources)


</script>

<style>

</style>